import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-frown",
  "use": "icon-frown-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-frown\" id=\"icon-frown\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M16 16s-1.5-2-4-2-4 2-4 2\" /><line x1=\"9\" y1=\"9\" x2=\"9.01\" y2=\"9\" /><line x1=\"15\" y1=\"9\" x2=\"15.01\" y2=\"9\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol